import React from "react";
import styles from "./heroSectionPage.module.scss";
import { Button } from "@mui/material";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import { useNavigate } from "react-router-dom";

const HeroSectionPage = () => {
  console.log("success");

  let navigate = useNavigate();

  function navigateSignup(params) {
    navigate("/signup");
  }

  return (
    <div className={styles.container} id="hero">
      <div className={styles.wrapper}>
        <div className={styles.heading}>
          <div className={styles.head1}>Welcome To </div>
          <div className={styles.placement}>
            <div className={styles.head2}>Kriha</div>
            <span>R</span>
          </div>
          <div className={styles.head3}>Megam </div>
        </div>
        <div className={styles.subHeading}>
          Empower Your Cloud Scale Without Limits
        </div>
        <div className={styles.heading}>
          Cost optimization in cloud devops implementation in performance of the
          business model of the careers model.
        </div>
        <Button
          variant="contained"
          onClick={navigateSignup}
          classes={{ root: styles.middleBtn }}
        >
          Request For Free Demo
        </Button>
        <div className={styles.bottom}>
        <a href="#ourServices">
          <button variant="outlined" startIcon={<ArrowDownwardIcon />}>
            <ArrowDownwardIcon />
            Our Services
          </button>
        </a>
      </div>
      </div>
      
    </div>
  );
};

export default HeroSectionPage;
